module.exports = __webpack_public_path__ + "static/media/basis-grotesque-bold.1c8afeaa.ttf";